import { render, staticRenderFns } from "./BaseNoRecordFound.vue?vue&type=template&id=d06ae3ee"
import script from "./BaseNoRecordFound.vue?vue&type=script&lang=js"
export * from "./BaseNoRecordFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports